/* CUSTOM JAVASCRIPT FILE FOR EVERY PAGE
* 
* AOS Animation
* Search Bar Collapse
* Mobile Navigation behavior & Bootstrap formatting
* Top-Level Menu Bug Fix (Bootstrap 5 compatible)
*/

(function ($) {
  $(document).ready(function () {
    // Initialize AOS
    if (typeof AOS !== 'undefined') {
      document.querySelectorAll('[data-aos]').forEach(function (el) {
        el.removeAttribute('data-aos-id');
      });
      
    AOS.init({
      disable: window.matchMedia("(max-width: 768px)").matches || window.matchMedia("(prefers-reduced-motion: reduce)").matches,
      offset: 120,
      delay: 0,
      duration: 600,
      easing: "ease-in-out",
      once: true,
      mirror: false,
      disableMutationObserver: true,
      anchorPlacement: "top-bottom",
    });
  }
    // Focus on search input when its container is shown
    $("#searchCollapse").on("shown.bs.collapse", function () {
      $(this).find('input[type="search"]').focus();
    });

    const $menuMainOffcanvas = $("#menu-main-offcanvas");

    // Handle submenu (inside a top-level dropdown)
    $menuMainOffcanvas.on("click", ".dropdown-item", function (e) {
      const $submenu = $(this).next(".dropdown-menu");
      if (
        $(this).attr("href").trim() !== "#" &&
        $(this).attr("href").trim() !== ""
      ) {
        return; // Allow real links to work normally
      }
      if ($submenu.length) {
        e.preventDefault();
        e.stopPropagation();

        // Toggle the immediate submenu
        $submenu.toggleClass("show");

        // Update aria-expanded
        const isExpanded = $submenu.hasClass("show");
        $(this).attr("aria-expanded", isExpanded);

        // Close siblings
        $(this)
          .parent()
          .siblings()
          .find(".dropdown-menu.show")
          .removeClass("show")
          .prev(".dropdown-item")
          .attr("aria-expanded", false);

        return false;
      }
    });

    // Clean up submenus when clicking outside
    $(document).on("click", function (e) {
      if (!$(e.target).closest("#menu-main-offcanvas").length) {
        $menuMainOffcanvas
          .find(".dropdown-menu.show")
          .removeClass("show")
          .prev(".dropdown-item")
          .attr("aria-expanded", false);
      }
    });

    // Bootstrap natural top-level dropdown handling
    // ON hiding a top-level dropdown, clean up any leftover submenus
    $menuMainOffcanvas.on('hide.bs.dropdown', function (e) {
      const $dropdown = $(e.target);
      $dropdown.find('.dropdown-menu.show')
        .removeClass('show')
        .prev('[aria-expanded=true]')
        .attr('aria-expanded', 'false');
    });

    // Nothing touches show.bs.dropdown
    // Bootstrap will handle the opening naturally
  });
})(jQuery);
